import { styled, css, Box, InputBase } from '@mui/material'
import IconButton from '../IconButton'

export const SearchBarWrapper = styled(Box)(
  () => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 56px;
    gap: 12px;
    padding-right: 16px;
    padding-left: 16px;
  `
)

export const SearchBarSide = styled(Box)(
  () => css`
    display: flex;
    align-items: center;
    min-width: 28px;

    &:first-of-type {
      margin-left: -8px;
    }

    &:last-of-type {
      margin-right: -8px;
    }
  `
)

export const SearchBarContent = styled(Box)(
  () => css`
    flex: 1;
    display: flex;
    align-items: center;
  `
)

export const SearchBarInput = styled(InputBase)(
  () => css`
    width: 100%;

    input {
      appearance: none;
      font-size: 1rem;
    }
  `
)

export const SearchBarBackButton = styled(IconButton)(() => css``)
SearchBarBackButton.defaultProps = {
  icon: 'MdOutlineArrowBack'
}

export const SearchBarClearButton = styled(IconButton)(() => css``)
SearchBarClearButton.defaultProps = {
  icon: 'MdClear'
}
